module.exports = __webpack_public_path__ + "img/refresh.0247f5d3.svg";